import React from "react";

import useDelayOnPropChange from "../../../../hooks/useDelayOnPropChange";
import { Icon } from "../../../content";
import { Box, Center } from "../../../layout";
import { IconButtonSize } from "../../IconButton";
import { ButtonSize } from "../types";

const ButtonSizeToIconSizeMap: { [key in ButtonSize]: IconButtonSize } = {
  standard: "large",
  small: "medium"
};

type Props = {
  children: React.ReactNode;
  loading: boolean;
  size: ButtonSize;
};

export default function ButtonLoadingStateProvider(props: Props) {
  const { children, loading, size } = props;

  const delayedLoadingProp = useDelayOnPropChange(loading);

  return (
    <Center>
      <Box position="absolute">
        {delayedLoadingProp && (
          <Icon
            accessibilityLabel="Loading..."
            iconName="senecaLoader"
            size={ButtonSizeToIconSizeMap[size]}
          />
        )}
      </Box>
      <Box transform={delayedLoadingProp ? "scale(0)" : undefined}>
        {children}
      </Box>
    </Center>
  );
}
